<template>
  <div class="w-full inline-flex flex-col justify-center">
   <!-- selection filtre : tram / bus / les deux -->
   <div v-if='$store.state.isSearch && $store.state.query.trim()' class="w-full inline-flex flex-col justify-center">
      <div class="w-full">
        <div class="mb-4 w-full text-gray-700 dark:text-white border-b border-gray-300 pb-1">
          <span class="ml-4">On part comment ?</span>
        </div>

        <div class="inline-flex items-center rounded-full text-gray-800 bg-gray-200 text-sm p-1 justify-between w-full h-10">
          <div
            class="p-2 rounded-full cursor-pointer w-1/2 text-center noSelect"
            v-for="filter in filters"
            :key="filter"
            :class='{"bg-white": selectedFilter === filter }'
            role='button'
            :aria-pressed="selectedFilter === filter ? 'true' : 'false'"
            @click="selectFilter(filter)"
          >
            {{ filter }}
          </div>
        </div>
      </div>
    </div>

    <div v-if='!$store.state.query.trim()' class="w-full inline-flex flex-col justify-center mb-4">
      <div class="w-full">
        <div class="mt-2 mb-2 w-full text-gray-700 dark:text-white border-b border-gray-300 pb-1">
          <!-- <span class="ml-4">Recherche par ligne</span> -->
          <span class="ml-4">On part avec quelle ligne ?</span>
        </div>
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide
            v-for="(l, k) in chunkedLines"
            :key="k"
            class="w-1/3 inline-flex flex-row flex-wrap justify-center mt-2"
          >
          <div class="inline-flex flex-row flex-wrap justify-center" style='max-width: 200px;'>
            <Ligne
              v-for="(line, kk) in l"
              :key="kk"
              class="m-1 cursor-pointer"
              :name="line.toString()"
              @selected-click="$router.push({ name: 'searchLigne', params: { ligne: line } }); selectFilter(line)"
              @click="selectFilter(line)"
              :size="'large'"
            />
            </div>
          </swiper-slide>

          <div class="swiper-button-prev outline-none" slot="button-prev"></div>
          <div class="swiper-button-next outline-none" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div v-if="$store.state.query.trim().length || $store.state.query.trim().length && selectedFilter === 'les deux' || selectedFilter !== 'les deux'">
      <div
        class="inline-flex justify-between mt-2 mb-4 w-full text-gray-700 dark:text-white border-b border-gray-300 pb-1"
      >
        <p class="mt-2">
          <span alt='Les arrêts' class="ml-4" v-if='selectedFilter'>Les arrêts </span>
          <span alt="Ligne passant par l'arrêt" class="ml-4" v-else>Ligne passant par l'arrêt </span>
          <span
            v-if="filters.includes(selectedFilter)"
            :alt="'de ' + (selectedFilter === 'les deux' ? 'bus & trams' : selectedFilter)"
          >
              de {{ selectedFilter === 'les deux' ? 'bus & trams' : `${selectedFilter}` }}
          </span>
          <span
            v-else-if="selectedFilter"
            :alt='"de la ligne " + selectedFilter'
          >
            de la ligne {{ selectedFilter }}
          </span>
        </p>
        <img
          v-if='selectedFilter && selectedFilter.length <= 2'
          src="/images/cross.svg"
          alt='Supprimer la recherche'
          style="height: 20px; width: 20px; margin-top: 11px;"
          @click="selectedFilter = 'les deux'; $router.push('/');"
        >
      </div>
      <div
        class="w-full inline-flex flex-col items-center rounded-lg overflow-y-scroll overflow-x-hidden"
        style="max-height: 60vh;"
      >
        <div class="inline-flex flex-col w-full h-auto rounded-lg bg-white dark:bg-transparent">
          <div
            v-for="(i, k) in searchFromFilter()"
            @click='select(i)'
            :key="`${k}-${i.id}`"
            :class="{'border-b-2 border-gray-200 dark:border-neutral-900': filteredCount > 1}"
            :aria-label='"ligne " + i.ligne + " station " + i.stations[0]'
          >
            <LigneStation
              class="m-2"
              :ligne="i.ligne"
              :station="i.stations[0]"
            />
          </div>
          <div v-if='filteredCount == 0' class="text-center text-xl text-gray-700 dark:text-white p-2">
            Aucun résultat
          </div>
        </div>
      </div>
    </div>

      <!-- Max ads  -->
    <div v-else class="w-full mt-6 left-0 space-y-4">
      <Infos
        size='xl'
        style='right: 0!important;left: 0!important;bottom: 0!important;'
      />
      <Plus />
    </div>

  </div>
</template>
<style type="text/css">
@media (max-width: 600px) and (max-height: 600px){
  .infoHide { display:none; }
}

</style>
<script>
import Ligne from "@/components/Ligne";
import LigneStation from "@/components/LigneStation";
import Infos from "@/components/Infos.vue";
import Plus from "@/components/Plus.vue";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Search",
  components: {
    Ligne,
    LigneStation,
    swiper,
    swiperSlide,
    Infos,
    Plus
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      filters: ["trams", "les deux", "bus"],
      selectedFilter: 'les deux',
      chunkedLines: [],
      lines: [],
      stops: [],
      filteredCount: 1,
    };
  },
  mounted() {
    this.lines = this.$store.state.lines;
    this.stops = this.$store.state.stops;
    this.selectedFilter = this.selectedFilter || this.$store.state.selectedFilter || null;

    const chunk = (a, l) => {
      return new Array(Math.ceil(a.length / l))
        .fill(0)
        .map((_, n) => a.slice(n * l, n * l + l));
    };

    Array.prototype.naturalSort= function(){
      var a, b, a1, b1, rx=/(\d+)|(\D+)/g, rd=/\d+/;
      return this.sort(function(as, bs){
          a= String(as).toLowerCase().match(rx);
          b= String(bs).toLowerCase().match(rx);
          while(a.length && b.length){
              a1= a.shift();
              b1= b.shift();
              if(rd.test(a1) || rd.test(b1)){
                  if(!rd.test(a1)) return -1;
                  if(!rd.test(b1)) return 1;
                  if(a1!= b1) return a1-b1;
              }
              else if(a1!= b1) return a1> b1? 1: -1;
          }
          return a.length- b.length;
      });
    }

    // this.chunkedLines = chunk(this.lines.map((i) => i.ligne).naturalSort(), 8);
    this.chunkedLines = chunk(this.lines.map((i) => i.ligne), 8);
  },
  methods: {
    select(station) {
      const ligne = station.ligne;
      const direction = station.direction[station.selected];
      const arret = station.stations[0];
      this.$store.commit("search", '');
      this.$store.commit("select", station);
      this.$store.dispatch("call");
      this.$router.push({name: 'shareHome', params: {ligne, direction, arret}});
    },
    selectFilter(filter) {
      if (this.selectedFilter !== filter) {
        this.selectedFilter = this.selectedFilter === filter ? null : filter;
      }
    },
    searchFromFilter() {
      const search = this.$store.state.query.toLowerCase().trim();

      let lines = this.lines;
      let stops = this.stops;
      let data = [];

      // Only trams
      if (this.selectedFilter == "trams") {
        lines = [this.lines.find(l => l.ligne === 'A')];
      }

      // Only bus
      if (this.selectedFilter == "bus") {
        lines = this.lines.filter(l => l.ligne !== 'A');
      }

      if (this.selectedFilter !== 'les deux') {
        // Filter by selected ligne
        const linesName = this.chunkedLines.flat();
        if (linesName.includes(this.selectedFilter)) {
          lines = this.lines.filter(l => l.ligne === this.selectedFilter);
        }
      }

      data = lines.map(line => line.stations.map(st => {
        return {...line, stations: [st]}
      }))

      // Filter on stations
      data = [...data].filter(i => i).flat();

      if (search.length) {

        data = data.map(line => {
          const filteredStations = line.stations.filter(st => st.toLowerCase().includes(search));
          if (filteredStations.length) {
            line.stations = filteredStations;
            return line
          }
          return null;
        }).filter(i => i)
      }

      // No filter and no search -> random res
      if (!this.selectedFilter && !search.length) {
        data = data.flat().sort(() => Math.random() - 0.5);
        data = data.slice(0, 10);
      }

      // Limit to 20 result (high cpu usage)
      if (search) {
        this.filteredCount = data.length > 20 ? 20 : data.length;
        return data.slice(0, 19);
      }

      this.filteredCount = data.length;
      return data;
    }
  }
};
</script>
